import React from "react";

const ThemeLayout = ({ children }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        margin: 0,
        padding: 0,
        backgroundColor: "var(--bgPrimary)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <main className="main candleyogi">{children}</main>
    </div>
  );
};

export default ThemeLayout;
